import { TrendPoint } from '../../app/models/trend-chart.model';

export class InactiveDataPlugin {
  public static createInactiveBackgroundPlugin(raw: TrendPoint[]) {
    let cachedInactiveCanvas: HTMLCanvasElement | null = null;
    let lastDataHash: string | null = null;
    let lastChartAreaHash: string | null = null;

    return {
      id: 'inactiveBackgroundPlugin',

      afterUpdate: (chart: any, args: any, options: any) => {
        const { chartArea, scales } = chart;

        if (!chartArea || !scales.x) {
          return;
        }

        const dataHash = JSON.stringify(
          raw.map((p) => ({ ts: p.ts, ac: p.activationCondition }))
        );
        const chartAreaHash = `${chartArea.left}-${chartArea.top}-${chartArea.width}-${chartArea.height}`;

        if (
          dataHash === lastDataHash &&
          chartAreaHash === lastChartAreaHash &&
          cachedInactiveCanvas
        ) {
          return;
        }

        lastDataHash = dataHash;
        lastChartAreaHash = chartAreaHash;

        const inactivePeriods = this.getInactivePeriods(raw);

        if (!cachedInactiveCanvas) {
          cachedInactiveCanvas = document.createElement('canvas');
        }

        cachedInactiveCanvas.width = chartArea.width;
        cachedInactiveCanvas.height = chartArea.height;

        const cacheCtx = cachedInactiveCanvas.getContext('2d');
        if (!cacheCtx) return;

        cacheCtx.clearRect(
          0,
          0,
          cachedInactiveCanvas.width,
          cachedInactiveCanvas.height
        );
        cacheCtx.fillStyle = 'rgba(128, 128, 128, 0.2)';

        inactivePeriods.forEach((period) => {
          const startDate = new Date(period.start);
          const endDate = new Date(period.end);

          const xStart = scales.x.getPixelForValue(startDate);
          const xEnd = scales.x.getPixelForValue(endDate);

          if (!isNaN(xStart) && !isNaN(xEnd)) {
            const adjustedXStart = xStart - chartArea.left;
            const adjustedXEnd = xEnd - chartArea.left;

            cacheCtx.fillRect(
              adjustedXStart,
              0,
              adjustedXEnd - adjustedXStart,
              chartArea.height
            );
          }
        });
      },

      beforeDatasetsDraw: (chart: any, args: any, options: any) => {
        const { ctx, chartArea } = chart;
        if (!cachedInactiveCanvas) return;

        ctx.save();
        ctx.drawImage(cachedInactiveCanvas, chartArea.left, chartArea.top);
        ctx.restore();
      },
    };
  }

  private static getInactivePeriods(
    raw: TrendPoint[]
  ): Array<{ start: string; end: string }> {

    const periods: Array<{ start: string; end: string }> = [];
    let inactiveStart: string | null = null;

    for (let i = 0; i < raw.length; i++) {
      const point = raw[i];

      if (!point.activationCondition && inactiveStart === null) {
        inactiveStart = point.ts;
      } else if (point.activationCondition && inactiveStart !== null) {
        periods.push({
          start: inactiveStart,
          end: raw[i - 1]?.ts || point.ts,
        });
        inactiveStart = null;
      }
    }

    if (inactiveStart !== null) {
      periods.push({
        start: inactiveStart,
        end: raw[raw.length - 1].ts,
      });
    }
    return periods;
  }
}
